import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { MatchRoundAccuracyStatsCategories } from '../../../../../helpers';
import { IRoundBoxScoreDto } from '../../../../../WorldDoomLeague';
import MatchRoundWeaponsAccuracyTable from './MatchRoundWeaponsAccuracyTable';

interface MatchRoundWeaponCategoryAccuracyTabsViewProps {
    categoryObject: MatchRoundAccuracyStatsCategories;
    activeWeapon: string;
    perRoundBoxScore: IRoundBoxScoreDto;
};

const MatchRoundWeaponCategoryAccuracyTabsView = (props: MatchRoundWeaponCategoryAccuracyTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.activeWeapon}>
                {props.categoryObject && props.categoryObject.AccuracyWeaponCategories.map((s, idx) => (
                    <TabPane tabId={s} key={idx}>
                        <MatchRoundWeaponsAccuracyTable activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} perRoundBoxScore={props.perRoundBoxScore} />
                    </TabPane>
                    ))}
            </TabContent>
        </React.Fragment>);
};

export default MatchRoundWeaponCategoryAccuracyTabsView;